import React, { useCallback, useState } from "react";
import ContentLoader from "react-content-loader";

const NakiNigunAlbumTrackListLoaderTemplate = ({ listNumber = 4 }) => {
    const [loaderWidth, setLoaderWidth] = useState(0);

    const ref = useCallback((node) => {
        if (node !== null) setLoaderWidth(node.getBoundingClientRect().width);
    }, []);

    return (
        <div ref={ref}>
            {Array.from({ length: listNumber }, () => {
                return (
                    <ContentLoader
                        speed={2}
                        width={loaderWidth}
                        height="170"
                        viewBox={`0 0 ${loaderWidth} 170`}
                        backgroundColor="#393c42"
                        foregroundColor="#404143"
                    >
                        <rect x="0" y={0} rx="6" ry="6" width="150" height="150" />

                        <rect x="170" y={4} rx="6" ry="6" width="60" height="12" />
                        <rect x="170" y={38} rx="6" ry="6" width="170" height="30" />

                        <rect x="170" y={90} rx="4" ry="4" width="100" height="8" />
                        <rect x="170" y={105} rx="6" ry="6" width={loaderWidth - 170} height="40" />
                    </ContentLoader>
                );
            })}
        </div>
    );
};

export default NakiNigunAlbumTrackListLoaderTemplate;
